import { IViewModel } from '../../interfaces/view-model.interface';

export class ExcelImportExportTemplate implements IViewModel {
    public id: number; // Note:  this dummy value is not used.

    public templateBase64Representation: string;
}
